import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import useInfiniteScroll from "hooks/useInfinteScroll";
import { debounce, uniqBy } from "lodash";
import React, { useEffect, useState } from "react";
import { spaceActions } from "redux/Ldb/actions/spaceActions";

const useGetSpaceNotes = (scrollContainer: any, spaceId: string, refetch: boolean) => {
    const dispatch = useAppDispatch();
    const [spaceNotes, setSpaceNotes] = useState<any[]>([]);
    const [pagination, setPagination] = useState<{ currentPage: string; noOfPages: string }>({
        currentPage: "1",
        noOfPages: "",
    });
    const [search, setSearch] = useState<string>("");
    const [debouncedSearch, setDebouncedSearch] = useState<string>("");
    const [memberId, setMemberId] = useState<string>("");
    const [sortBy, setSortBy] = useState<string>("");
    const [fetching, setFetching] = useState<boolean>(true);

    const { fetchingSpaceNotes, fetchSpaceNotesSuccess } = useAppSelector((state) => state.space);

    const { updatedLimit, isLoadingMore, setLoadMore, updatedPage, setUpdatedPage } =
        useInfiniteScroll(
            { current: pagination.currentPage, number_of_pages: pagination.noOfPages },
            20,
            scrollContainer
        );

    useEffect(() => {
        setUpdatedPage(1);
    }, [memberId, sortBy, refetch]);

    useEffect(() => {
        if (spaceId) {
            dispatch(
                spaceActions.getSpaceNotes(
                    spaceId,
                    updatedPage,
                    20,
                    debouncedSearch,
                    memberId,
                    sortBy
                )
            );
        }
    }, [dispatch, spaceId, debouncedSearch, updatedPage, refetch, memberId, sortBy]);

    const handleDebouncedSearch = debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        setDebouncedSearch(e?.target?.value);
        setUpdatedPage(1);
    }, 3000);

    useEffect(() => {
        if (Boolean(fetchSpaceNotesSuccess)) {
            setSpaceNotes((prev) =>
                updatedPage === 1
                    ? uniqBy([...fetchSpaceNotesSuccess?.data?.notes], "_id")
                    : uniqBy([...prev, ...fetchSpaceNotesSuccess?.data?.notes], "_id")
            );
            setPagination({
                currentPage: fetchSpaceNotesSuccess?.data?.pagination?.current,
                noOfPages: fetchSpaceNotesSuccess?.data?.pagination?.number_of_pages,
            });
            setLoadMore(false);
            setFetching(false);
            dispatch(spaceActions.resetGetSpaceNotes());
        }
    }, [dispatch, fetchSpaceNotesSuccess]);

    return {
        spaceNotes,
        fetchingSpaceNotes,
        setDebouncedSearch,
        debouncedSearch,
        pagination,
        setPagination,
        search,
        setSearch,
        isLoadingMore,
        handleDebouncedSearch,
        setMemberId,
        memberId,
        setSortBy,
        sortBy,
        fetching,
    };
};

export default useGetSpaceNotes;
